<!-- Both p-fileupload modes have their inconvenience:
        In basic we can not disable that the "select" button also permits to start the upload.
        In advanced mode, the content area can not be hidden.
        Current solution: Use advanced mode, use the content area.
    -->
<p-fileUpload #fileUploadComponent
                mode="advanced"
                chooseLabel="{{'fs.res.publication.import.searchFile' | hisUi}}"
                name="file"
                accept=".xls,.xlsx"
                [files]="selectedFileArray"
                [url]="uploadUrl"
                [showUploadButton]="false"
                [showCancelButton]="false"
                (onSelect)="onSelect($event)"
                (onUpload)="onUpload($event)"
                (onError)="onError($event)">

    <ng-template pTemplate="content">
        <div  class="infoMessage">
            <span *ngIf="!selectedFile">
                {{'fs.res.publication.import.noFileSelected' | hisUi}}
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="file">
        <div>
            <span *ngIf="selectedFile">
                {{'fs.res.publication.import.selectedFile' | hisUi}} {{selectedFile.name}} ({{selectedFile.size}} bytes)
            </span>
        </div>
    </ng-template>

</p-fileUpload>

<p></p>

<!-- Start upload and import of the selected file. -->
<button [disabled]="!selectedFile" (click)="doImport()" hisImage="LINE_OUT" class="transparent"><span>{{'fs.res.publication.import.start' | hisUi}}</span></button>

<!-- This entry is required to define a key because there seems to be another confirmDialog in p-fileupload. -->
<!-- acceptIcon and rejectIcon must be deleted explicitly to get rid of fa icons. -->
<p-confirmDialog
    key="publicationImport"
    acceptIcon=""
    rejectIcon=""
    [acceptLabel]="'de.his.javang.ja' | hisUi"
    [rejectLabel]="'de.his.javang.nein' | hisUi">
</p-confirmDialog>
